import { FC, useEffect, useState } from "react";
import { useForm } from "../../app/useForm";
import { BadgesWithInput } from "../../../ui/layout/organisms/BadgedText/BadgesWithInput";

type TagListProps = {
  value?: string[];
  name?: string;
  disabled?: boolean;
  placeholder?: string;
};

export const TagList: FC<TagListProps> = ({
  value,
  name,
  disabled,
  placeholder,
}) => {
  const { handleFieldChange } = useForm();
  const [tags, setTags] = useState(value ?? []);

  useEffect(() => {
    setTags(value ?? []);
  }, [value]);

  if (disabled) return <>{tags.join(", ")}</>;

  return (
    <BadgesWithInput
      actualCustomData={tags}
      currentActiveData={tags}
      handleBadgedData={(newTags) => {
        setTags(newTags);
        handleFieldChange(name, newTags);
      }}
      inputPlaceholder={placeholder ?? "example.com"}
    />
  );
};
